import ApiService from "../../../../services/ApiService";
import { truncateString } from "../../../../services/UtilityService";

export const fetchUserMessages = (userId: number, setMessages: Function, setLoading: Function) => {
  setLoading(true);

  ApiService.get(`users/${userId}/messages`)
    .then((response) => {
      setMessages(
        response.data.messages.map((message: any) => ({
          id: message.id.toString(),
          author: message.author_name,
          author_id: message.author_id,
          email: message.author_email,
          date: message.dt_added,
          fullContent: message.content,
          content: truncateString(message.content, 100, true),
          dt_seen: message.dt_seen,
        }))
      );
    })
    .catch((error) => console.error("An error occurred while fetching user's messages", error))
    .finally(() => setLoading(false));
};
